// extracted by mini-css-extract-plugin
export default {"reasonLayout":"ReasonLayout_reasonLayout__rwpsR"};